import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { KeyHandlerDirective } from '../../../directives/key-handler.directive';

@Component({
    selector: 'lex-add-docs-to-review-set-dialog',
    templateUrl: './add-docs-to-review-set-dialog.component.html',
    styleUrls: ['./add-docs-to-review-set-dialog.component.scss'],
    standalone: false
})
export class AddDocsToReviewSetDialogComponent extends KeyHandlerDirective {

	public reviewSetName: string;
	public selectedDocCount: number;
	public expandedDocCount: number;
	public expandDocs: boolean;

	constructor(private dialogRef: MatDialogRef<AddDocsToReviewSetDialogComponent>, @Inject(MAT_DIALOG_DATA) data) {
		super();
		if (data) {
			this.expandDocs = data.expandDocs ?? false;
			this.selectedDocCount = data.selectedDocCount ?? 0;
			this.expandedDocCount = data.expandedDocCount ?? 0;
			this.reviewSetName = data.reviewSetName ?? '';
		}
	}

	public ok() {
		this.dialogRef.close(this.expandDocs);
	}

	public cancel() {
		this.dialogRef.close(null);
	}
}
